import { moroccoRegions } from "@/data/parties";
import { translations, Lang } from "@/i18n/translations";

const provinceTranslationsAr: Record<string, string> = {
  // Tanger-Tétouan-Al Hoceïma
  "Tanger-Assilah": "طنجة-أصيلة",
  "M'diq-Fnideq": "المضيق-الفنيدق",
  "Tétouan": "تطوان",
  "Fahs-Anjra": "الفحص-أنجرة",
  "Larache": "العرائش",
  "Al Hoceïma": "الحسيمة",
  "Chefchaouen": "شفشاون",
  "Ouezzane": "وزان",
  
  // L'Oriental
  "Oujda-Angad": "وجدة-أنجاد",
  "Nador": "الناظور",
  "Driouch": "الدريوش",
  "Jerada": "جرادة",
  "Berkane": "بركان",
  "Taourirt": "تاوريرت",
  "Guercif": "جرسيف",
  "Figuig": "فكيك",

  // Fès-Meknès
  "Fès-Sud": "فاس-الجنوبية",
  "Fès-Nord": "فاس-الشمالية",
  "Meknès": "مكناس",
  "El Hajeb": "الحاجب",
  "Ifrane": "إفران",
  "Moulay Yacoub": "مولاي يعقوب",
  "Sefrou": "صفرو",
  "Boulemane": "بولمان",
  "Taounate-Tissa": "تاونات-تيسة",
  "Karia-Ghafsay": "قرية با محمد-غفساي",
  "Taza": "تازة",

  // Rabat-Salé-Kénitra
  "Rabat-Chellah": "الرباط-شالة",
  "Rabat-Océan": "الرباط-المحيط",
  "Salé-Médina": "سلا-المدينة",
  "Salé-Jadida": "سلا-الجديدة",
  "Skhirate-Témara": "الصخيرات-تمارة",
  "Kénitra": "القنيطرة",
  "Gharb": "الغرب",
  "Khémisset-Oulmès": "الخميسات-أولماس",
  "Tiflet-Rommani": "تيفلت-الرماني",
  "Sidi Kacem": "سيدي قاسم",
  "Sidi Slimane": "سيدي سليمان",

  // Béni Mellal-Khénifra
  "Béni Mellal": "بني ملال",
  "Azilal-Demnate": "أزيلال-دمنات",
  "Bzou-Ouaouizeght": "بزو-واويزغت",
  "Fquih Ben Salah": "الفقيه بن صالح",
  "Khénifra": "خنيفرة",
  "Khouribga": "خريبكة",

  // Casablanca-Settat
  "Casablanca-Anfa": "الدار البيضاء-أنفا",
  "Aïn Sebaâ-Hay Mohammadi": "عين السبع-الحي المحمدي",
  "Moulay Rachid": "مولاي رشيد",
  "Sidi Bernoussi": "سيدي البرنوصي",
  "Hay Hassani": "الحي الحسني",
  "Al Fida-Mers Sultan": "الفداء-مرس السلطان",
  "Ben M'sik": "ابن مسيك",
  "Aïn Chock": "عين الشق",
  "Mohammédia": "المحمدية",
  "El Jadida": "الجديدة",
  "Settat": "سطات",
  "Berrechid": "برشيد",
  "Benslimane": "بنسليمان",
  "Médiouna": "مديونة",
  "Nouaceur": "النواصر",
  "Sidi Bennour": "سيدي بنور",

  // Marrakech-Safi
  "Gueliz-Nakhil": "جليز-النخيل",
  "Ménara": "المنارة",
  "Sidi Youssef Ben Ali": "سيدي يوسف بن علي",
  "Chichaoua": "شيشاوة",
  "Al Haouz": "الحوز",
  "Essaouira": "الصويرة",
  "El Kelâa des Sraghna": "قلعة السراغنة",
  "Rehamna": "الرحامنة",
  "Safi": "أسفي",
  "Youssoufia": "اليوسفية",

  // Drâa-Tafilalet
  "Errachidia": "الرشيدية",
  "Ouarzazate": "ورزازات",
  "Midelt": "ميدلت",
  "Tinghir": "تنغير",
  "Zagora": "زاكورة",

  // Souss-Massa
  "Agadir-Ida Ou Tanane": "أكادير-إداوتنان",
  "Inezgane-Aït Melloul": "إنزكان-أيت ملول",
  "Chtouka-Aït Baha": "شتوكة أيت باها",
  "Taroudant-Nord": "تارودانت-الشمالية",
  "Taroudant-Sud": "تارودانت-الجنوبية",
  "Tiznit": "تيزنيت",
  "Tata": "طاطا",

  // Guelmim-Oued Noun
  "Guelmim": "كلميم",
  "Assa-Zag": "آسا الزاك",
  "Tan-Tan": "طانطان",
  "Sidi Ifni": "سيدي إفني",

  // Laâyoune-Sakia El Hamra
  "Laâyoune": "العيون",
  "Boujdour": "بوجدور",
  "Tarfaya": "طرفاية",
  "Es-Semara": "السمارة",

  // Dakhla-Oued Ed-Dahab
  "Oued Ed-Dahab": "وادي الذهب",
  "Aousserd": "أوسرد"
};

export const getTranslatedRegion = (reg: string, lang: string) => {
  if (!reg) return reg;
  // Handle case where Arabic/Amazigh is already passed
  const alreadyAr = moroccoRegions.find(r => r.nameAr === reg);
  if (alreadyAr) return lang === "ar" ? alreadyAr.nameAr : lang === "zgh" ? alreadyAr.nameZgh : alreadyAr.name;
  
  const alreadyZgh = moroccoRegions.find(r => r.nameZgh === reg);
  if (alreadyZgh) return lang === "ar" ? alreadyZgh.nameAr : lang === "zgh" ? alreadyZgh.nameZgh : alreadyZgh.name;

  // Normalize string for robust French comparison (accents, spaces, smart quotes)
  const normalize = (s: string) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u2019’]/g, "'").toLowerCase().trim();
  const normalizedInput = normalize(reg);
  
  const region = moroccoRegions.find((r) => normalize(r.name) === normalizedInput);
  
  if (region) {
    if (lang === "ar") return region.nameAr || reg;
    if (lang === "zgh") return region.nameZgh || reg;
    return region.name; // return clean French name
  }
  return reg;
};

export const getTranslatedParty = (acronym: string, lang: string) => {
  if (!acronym) return acronym;
  const upper = acronym.toUpperCase().trim();
  const partyNames = translations[lang as Lang]?.parties?.partiesNames;
  if (partyNames && partyNames[upper]) {
    return partyNames[upper];
  }
  return acronym;
};

export const getTranslatedProvince = (prov: string, lang: string) => {
  if (!prov) return prov;
  
  // Handle case where Arabic is already passed
  const isAlreadyAr = Object.values(provinceTranslationsAr).includes(prov);
  if (isAlreadyAr && lang === "ar") return prov;
  if (isAlreadyAr && lang !== "ar") {
      // Find the French key for this Arabic value
      const frKey = Object.keys(provinceTranslationsAr).find(k => provinceTranslationsAr[k] === prov);
      return frKey || prov;
  }

  // Normalize string for robust French comparison
  const normalize = (s: string) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u2019’]/g, "'").toLowerCase().trim();
  const normalizedInput = normalize(prov);

  const frKey = Object.keys(provinceTranslationsAr).find(k => normalize(k) === normalizedInput);
  
  if (frKey) {
      if (lang === "ar") return provinceTranslationsAr[frKey];
      if (lang === "zgh") return frKey; // Fallback to French for now
      return frKey; // return clean French name
  }
  
  return prov;
};
